import React, { useState, useEffect } from 'react'
import apiRequest from '../hooks/ApiRequest'
import Layouts from '../components/Layouts'
import useDownloadPdf from '../hooks/DownloadPdf'
import { Table, Button, Input, Spin, Row, Col, Dropdown, Menu, DatePicker, Select } from 'antd'
import { SearchOutlined, FilterOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isBetween)

const CustomerStatement = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const { generatePdf } = useDownloadPdf()
  const [months, setMonths] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [allData, setAllData] = useState([])

  const UserDetail = JSON.parse(localStorage.getItem('user'))
  useEffect(() => {
    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/api/PaypalWebhook/getPaymenthistoryby-email?email=${UserDetail?.email}`,
      )
      //   setBaseData(response?.data)
      const filteredData = response?.data?.filter(
        item => item.payment_type?.toLowerCase() !== "Debit" && item.payment_type?.toLowerCase() !== "Credit"
      );
      setBaseData(filteredData);
      setAllData(filteredData)
      applyFilters(filteredData, months, startDate, endDate)
    } catch (error) {
      console.error('Error fetching insurers', error)
    } finally {
      setLoading(false)
    }
  }

  const applyFilters = (data = allData, selectedMonths = months, start = startDate, end = endDate) => {
    let result = [...data]

    if (selectedMonths) {
      const limitDate = dayjs().subtract(selectedMonths, 'month')
      result = result.filter(item =>
        dayjs(item.transaction_date, 'M/D/YYYY, h:mm:ss A').isAfter(limitDate)
      )
    }

    if (start && end) {
      result = result.filter(item =>
        dayjs(item.transaction_date, 'M/D/YYYY, h:mm:ss A').isBetween(start, end, 'day', '[]')
      )
    }

    setBaseData(result)
  }

  const handleSearch = () => {
    fetchRoles()
  }

  const groupByMonth = (data) => {
    return data.reduce((acc, item) => {
      if (!item.transaction_date || item.transaction_date === '0001-01-01T00:00:00') {
        return acc; // skip invalid date
      }

      const monthYear = dayjs(item.transaction_date).format('MMMM YYYY');
      if (!acc[monthYear]) acc[monthYear] = [];
      acc[monthYear].push(item);
      return acc;
    }, {});
  };


  const getGroupedDataWithLabels = (data) => {
    const grouped = groupByMonth(data)
    const flat = []

    Object.entries(grouped).forEach(([month, items]) => {
      flat.push({ isLabel: true, month, key: `label-${month}` })
      items.forEach((item, index) => {
        flat.push({ ...item, key: item.id || `${month}-${index}` })
      })
    })

    return flat
  }


  const columns = [
    {
      title: 'Transaction Reference',
      dataIndex: 'transaction_ref',
      key: 'transaction_ref',
      render: text => text || '—',
    },
    {
      title: 'Payment Amount',
      dataIndex: 'payment_amount',
      key: 'payment_amount',
      render: amount => `$${amount.toFixed(2)}`,
    },
    {
      title: 'Transaction Date',
      dataIndex: 'transaction_date',
      key: 'transaction_date',
      render: date =>
        date && date !== '0001-01-01T00:00:00'
          ? new Date(date).toLocaleString()
          : 'Not Available',
    },
  ]

  return (
    <Layouts title="Insurers" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={10}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Customer Statement
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={8}>
            <div className="item-search">
              <Input.Search
                placeholder="Search ..."
                prefix={<SearchOutlined />}
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={handleSearch}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={async () => {
                  if (!UserDetail?.email) return;
                  try {
                    const response = await fetch(
                      `${process.env.REACT_APP_BASE_URL}/api/PaypalWebhook/downloadPaymentHistoryPdf?email=${UserDetail.email}`,
                      {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/pdf',
                        },
                      }
                    );

                    if (!response.ok) {
                      console.error('Failed to download PDF');
                      return;
                    }

                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'payment-history.pdf';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                  } catch (err) {
                    console.error('Error downloading PDF:', err);
                  }
                }}
                style={{ marginLeft: 10 }}
              >
                Download
              </Button>
            </div>
          </Col>

          <Col xs={24} sm={24} md={6} lg={4}>
            <Select
              placeholder="Select months"
              value={months !== null ? months : undefined}
              onChange={value => {
                setMonths(value)
                setStartDate(null)
                setEndDate(null)
                applyFilters(allData, value, null, null)
              }}
              style={{ width: 160 }}
              allowClear
            >
              {[1, 3, 6, 12].map(m => (
                <Select.Option key={m} value={m}>
                  Last {m} month{m > 1 ? 's' : ''}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={24} sm={24} md={6} lg={4}>
            <DatePicker
              placeholder="Start Date"
              style={{ width: 160 }}
              value={startDate}
              onChange={value => {
                setStartDate(value)
                setMonths(null)
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={6} lg={4}>
            <DatePicker
              placeholder="End Date"
              style={{ width: 160 }}
              value={endDate}
              onChange={value => {
                setEndDate(value)
                setMonths(null)
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={3} lg={3}>
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={() => applyFilters(allData, months, startDate, endDate)}
            >
              Filter
            </Button>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ display: 'block', marginTop: 20 }}
        />
      ) : (
        <div id="divToPrint">
          <Table
            columns={columns}
            dataSource={getGroupedDataWithLabels(baseData)}
            rowClassName={(record) => (record.isLabel ? 'month-label-row' : '')}
            pagination={{ pageSize: 10 }}
            rowKey="key"
            // Conditionally render month label as full-width row
            components={{
              body: {
                row: ({ children, ...restProps }) => {
                  const record = children[0]?.props?.record
                  if (record?.isLabel) {
                    return (
                      <tr {...restProps}>
                        <td colSpan={columns.length} style={{ fontWeight: 'bold', padding: '10px', background: '#f0f2f5' }}>
                          {record.month}
                        </td>
                      </tr>
                    )
                  }
                  return <tr {...restProps}>{children}</tr>
                }
              }
            }}
          />
        </div>
      )}
    </Layouts>
  )
}

export default CustomerStatement
